import { CustomizeControllerArgs } from './index';
import BaseCustomizer from './base';

export default abstract class BaseGroupCustomizer extends BaseCustomizer {
  private readonly customizers: BaseCustomizer[] = [];
  private matchingCustomizers: BaseCustomizer[] = [];

  constructor(args: CustomizeControllerArgs) {
    super(args);
    this.customizers = this.getGroupedCustomizers(args);
  }

  /**
   * Returns true if the customizers under this group should be called at all,
   * useful when there is a common check across all customizers
   *
   */
  abstract shouldGroupCustomize(): Promise<boolean>;

  /**
   * Returns list of customizers grouped together and are gated behind the common check
   * implemented in shouldGroupCustomize
   * @param args {CustomizeControllerArgs}
   * @returns {BaseCustomizer[]}
   */
  abstract getGroupedCustomizers(args: CustomizeControllerArgs): BaseCustomizer[];

  async shouldCustomize() {
    const shouldGroupCustomize = await this.shouldGroupCustomize();
    if (shouldGroupCustomize) {
      for (const customizer of this.customizers) {
        const shouldCustomize = await customizer.shouldCustomize();
        if (shouldCustomize) {
          this.matchingCustomizers.push(customizer);
          return true;
        }
      }
    }
    return false;
  }

  async customize() {
    for (const matchingCustomizer of this.matchingCustomizers) {
      await matchingCustomizer.customize();
    }
  }
}
